export const CustomerPaymentMode = {
  InStoreOnly: 1,
  OnlineOnly: 2,
  Both: 3,
};

export const normalizeCustomerPaymentMode = (mode, fallback = CustomerPaymentMode.InStoreOnly) => {
  if (mode === CustomerPaymentMode.InStoreOnly || mode === 'InStoreOnly' || mode === 1) {
    return CustomerPaymentMode.InStoreOnly;
  }

  if (mode === CustomerPaymentMode.OnlineOnly || mode === 'OnlineOnly' || mode === 2) {
    return CustomerPaymentMode.OnlineOnly;
  }

  if (mode === CustomerPaymentMode.Both || mode === 'Both' || mode === 3) {
    return CustomerPaymentMode.Both;
  }

  return fallback;
};

export const allowsOnline = (mode) => {
  const normalized = normalizeCustomerPaymentMode(mode);
  return normalized === CustomerPaymentMode.OnlineOnly || normalized === CustomerPaymentMode.Both;
};

export const allowsInStore = (mode) => {
  const normalized = normalizeCustomerPaymentMode(mode);
  return normalized === CustomerPaymentMode.InStoreOnly || normalized === CustomerPaymentMode.Both;
};

export default CustomerPaymentMode;
